import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Token } from '../interface/Token';

@Injectable({
  providedIn: 'root'
})
export class rootService {

  //private apiUrl: string = 'https://productores.argbroker.com.ar'

  private apiUrl: string = environment.apiPlataforma;



  constructor(private http: HttpClient) { }

  getToken (usuario: string, password: string): Observable<Token>{
    const url = `${this.apiUrl}/auth/login`;

    const dataToSend = {
      email: usuario,
      password: password
    }

    return this.http.post<Token>(url, dataToSend);

  }
}
